if (typeof WDN === "undefined") {
  var WDN = {}; 
}

if (typeof WDN.Drawer === "undefined") {
  WDN.Drawer = (function () {
    // Public available?
    var List, Init;

    // Private var
    var Config, Body;

    Body = document.querySelector("body");

    // List to hold generated objects, to allow access in global scope
    List = {};

    Config = {
      link: "Drawer__link",
      bodyOpen: "Drawer--open",
      drawer: "Drawer",
      close: "Drawer__close-icon",
      openVertical: "Drawer--open-vertical",
      openHorizontal: "Drawer--open-horizontal",
      state: {
        opened: "opened",
        closed: "closed",
      },
    };

    var Drawers = document.querySelectorAll(`.${Config.drawer}`);

    var Constructor = function (id) {
      this.id = id;
      this.drawer = document.querySelector(`.${Config.drawer}[data-id='${id}']`);
      this.links = document.querySelectorAll(`.${Config.link}[data-id='${id}']`);

      this.state = Config.state.closed;
      this.closeIcon = document.querySelectorAll(`.${Config.close}[data-id='${id}']`);

      this.findAnimation();
      this.attachActions();

      this.closeOnEscape = function () {
        if (event.keyCode == 27) {
          this.close();
        }
      };

      this.closeOnClick = function () {
        if (event.target.classList.contains(Config.bodyOpen)) {
          this.close();
        }
      };

      this.closeOEscapeBound = this.closeOnEscape.bind(this);
      this.closeOnClickBound = this.closeOnClick.bind(this);
    };

    Constructor.prototype.attachActions = function () {
      this.bindClosers();
      this.bindOpeners();
    };

    Constructor.prototype.bindClosers = function () {
      this.closeIcon.forEach(function(elem) {
        elem.addEventListener("click", this.close.bind(this));
      }, this);
    };

    Constructor.prototype.bindOpeners = function () {
      if (this.links.length > 0) {
        this.links.forEach(function (link) {
          link.addEventListener("click", this.open.bind(this));
        }, this);
      }
    };

    Constructor.prototype._addEvent = function (event, func) {
      return window.addEventListener(event, func);
    };

    Constructor.prototype._removeEvent = function (event, func) {
      return window.removeEventListener(event, func);
    };

    // State updater things
    Constructor.prototype._stateOnUpdate = function () {
      if (this.state === Config.state.closed) {
        this.drawer.removeAttribute("data-open");
        this.drawer.classList.remove(this.currentAnimation);
        Body.classList.remove(Config.bodyOpen);
      } else {
        this.drawer.setAttribute("data-open", "");
        this.drawer.classList.add(this.currentAnimation);
        Body.classList.add(Config.bodyOpen);
      }
    };

    Constructor.prototype.findAnimation = function () {
      switch (this.drawer.dataset.animate) {
        case "top":
        case "bottom":
          this.currentAnimation = Config.openVertical;
          break;
        case "left":
          this.currentAnimation = Config.openHorizontal;
          break;
        default:
          this.currentAnimation = Config.openHorizontal;
      }
    };

    Constructor.prototype.bindEvents = function () {
      this._addEvent("keydown", this.closeOnKeyBound);
      this._addEvent("click", this.closeOnClickBound);
    };

    Constructor.prototype.removeEvents = function () {
      this._removeEvent("keydown", this.closeOnKeyBound);
      this._removeEvent("click", this.closeOnClickBound);
    };

    Constructor.prototype.stateUpdate = function (state) {
      this.state = state;
      this._stateOnUpdate();
    };

    Constructor.prototype.stateGet = function () {
      return this.state;
    };

    Constructor.prototype.onOpen = function () {
      if (this.callbacks) {
        if (this.callbacks.open) {
          this.callbacks.open.call(this);
        }
      }
    };

    Constructor.prototype.onClose = function () {
      if (this.callbacks) {
        if (this.callbacks.close) {
          this.callbacks.close.call(this);
        }
      }
    };

    Constructor.prototype.open = function () {
      this.stateUpdate(Config.state.opened);
      this.bindEvents();
      this.onOpen();
    };

    Constructor.prototype.close = function () {
      this.stateUpdate(Config.state.closed);
      this.removeEvents();
      this.onClose();
    };

    var Create = function (id) {
      var Obj = new Constructor(id);
      List[id] = Obj;
    };

    var Init = function () {
      if (Drawers.length > 0) {
        Drawers.forEach(function (Drawer) {
          if (typeof Drawer.dataset.id !== "undefined") {
            Create(Drawer.dataset.id);
          }
        });
      }
    };

    // Auto setup
    Init();

    return {
      List: List,
    };
  })();
}


if (typeof WDN.Navigation === 'undefined') {
  WDN.Navigation = (function () {

    var SublinkParents = document.querySelectorAll('.Drawer [data-navigation-has-sublinks]');

    var init, sublinkClickHandler;

    sublinkClickHandler = function (e) {
      if (e.target.classList.contains('Navigation-link') || e.target.classList.contains('Icon')) {
        e.preventDefault();
        if (this.dataset.linkExpanded === '') {
          this.removeAttribute('data-link-expanded');
        } else {
          this.setAttribute('data-link-expanded', '');
        }
      }
    };

    init = function () {
      if (SublinkParents.length > 0) {
        SublinkParents.forEach(function (parent) {
          parent.addEventListener('click', sublinkClickHandler);
        });
      }
    };

    init();

    return {};
  })();
}